import { path, flatten, pluck, compose } from 'ramda';
import { removeEmptyValues } from 'utils/functions';

export const getStationUic = path(['uic']);

export const getStationName = path(['name']);

const SWAP_STATIONS_DISABLED_REASONS = {
  GROUP_BOOKING: `swapStationsDisabledReason.groupBooking`,
  CONNECTING_TRAINS: `swapStationsDisabledReason.hasConnectedTrains`,
  HAS_AOP_ACTIVATED: `swapStationsDisabledReason.aopActivated`,
  RETURN_JOURNEY_WITH_ONE_WAY_EXCHANGE: `swapStationsDisabledReason.mustSelectAllLegsInAReturnBookingExchange`,
  NOT_ALL_PAXS_SELECTED: `swapStationsDisabledReason.mustSelectAllPassengers`
};

export const buildInboundInfo = ({ inboundDate, inboundOrigin, inboundDestination }) =>
  inboundDate && inboundOrigin && inboundDestination
    ? {
        date: inboundDate,
        origin: getStationName(inboundOrigin),
        originUIC: getStationUic(inboundOrigin),
        destination: getStationName(inboundDestination),
        destinationUIC: getStationUic(inboundDestination)
      }
    : null;

export const buildOutboundInfo = ({ outboundDate, outboundOrigin, outboundDestination }) =>
  outboundDate && outboundOrigin && outboundDestination
    ? {
        date: outboundDate,
        origin: getStationName(outboundOrigin),
        originUIC: getStationUic(outboundOrigin),
        destination: getStationName(outboundDestination),
        destinationUIC: getStationUic(outboundDestination)
      }
    : null;

export const buildStationsForSearch = ({
  outboundDate,
  inboundDate,
  outboundOrigin,
  outboundDestination,
  inboundOrigin,
  inboundDestination
}) => {
  if (outboundDate && inboundDate) {
    return removeEmptyValues({
      origin: outboundOrigin,
      destination: outboundDestination,
      returningOrigin: inboundOrigin,
      returningDestination: inboundDestination
    });
  }

  if (outboundDate) {
    return {
      origin: outboundOrigin,
      destination: outboundDestination
    };
  }

  if (inboundDate) {
    return {
      origin: inboundOrigin,
      destination: inboundDestination
    };
  }

  return {};
};

const getProductsFromLegs = compose(flatten, pluck('products'));

export const flattenProductsByLeg = (leg, refsExchanged) =>
  getProductsFromLegs(leg)
    ?.filter((productFromLeg) => refsExchanged.includes(Number(productFromLeg?.itemRef)))
    ?.map((exchangedProduct) => exchangedProduct?.code);

export const getReasonsForDisablingSwapStations = ({
  isGroupBooking = false,
  hasConnectingTrains = false,
  isAOPActivated = false,
  isTwoWayJourneyOneWayExchange = false,
  notAllPassengersSelected = false
}) => {
  if (isGroupBooking) return SWAP_STATIONS_DISABLED_REASONS.GROUP_BOOKING;
  if (hasConnectingTrains) return SWAP_STATIONS_DISABLED_REASONS.CONNECTING_TRAINS;
  if (isAOPActivated) return SWAP_STATIONS_DISABLED_REASONS.HAS_AOP_ACTIVATED;
  if (isTwoWayJourneyOneWayExchange) return SWAP_STATIONS_DISABLED_REASONS.RETURN_JOURNEY_WITH_ONE_WAY_EXCHANGE;
  if (notAllPassengersSelected) return SWAP_STATIONS_DISABLED_REASONS.NOT_ALL_PAXS_SELECTED;
  return '';
};
